<template>
  <hamv-dialog :dialogProps="dialogProps" :showModal="showModal">
    <span class="el-dialog__title" data-qa="Dialog-DeleteDevice-Title" slot="header">{{ $t('deviceLockDialogTitle') }}</span>
    <i18n path="deviceLockDialogConfirmText" data-qa="Dialog-DeleteDevice-ConfirmText" tag="span">
      <el-tag place="id" type="info">{{ id }}</el-tag>
    </i18n>
    <div slot="actions">
      <el-button
        :class="button.class"
        :data-qa="`Dialog-DeleteDevice-Button-${button.id}`"
        :key="index"
        :type="button.type || 'warning'"
        @click.stop="button.click"
        v-for="(button, index) in buttons"
      >
        {{ $t(button.text) }}
      </el-button>
    </div>
  </hamv-dialog>
</template>

<script>
  import main from './DeviceLock.js'
  export default main
</script>

<style lang="scss" scoped>
  @import './DeviceLock.scss'
</style>



// WEBPACK FOOTER //
// DeviceLock.vue?bc0885b6